import React from 'react';
import { InlineNotification, TextInput } from 'carbon-components-react';
import StripePaymentCard from './StripePaymentCard';
import PricingSummary, {
  PricingLineItem,
  PricingTotal
} from './PricingSummary';

interface PaymentScreenLayoutProps {
  bannerMessage: string;
  stripeAmount: string;
  stripeCurrency: string;
  stripeDescription: string;
  lineItems: PricingLineItem[];
  total: PricingTotal;
  purchaseOrderNumber: string;
  onPurchaseOrderNumberChange: (value: string) => void;
}

const PaymentScreenLayout: React.FC<PaymentScreenLayoutProps> = ({
  bannerMessage,
  stripeAmount,
  stripeCurrency,
  stripeDescription,
  lineItems,
  total,
  purchaseOrderNumber,
  onPurchaseOrderNumberChange
}) => {
  return (
    <div>
      <div className="payment-screen-layout__section payment-screen-layout__notification">
        <InlineNotification
          kind="info"
          title=""
          subtitle={bannerMessage}
          lowContrast
          hideCloseButton
        />
      </div>

      <div className="payment-screen-layout__section">
        <StripePaymentCard
          amount={stripeAmount}
          currency={stripeCurrency}
          description={stripeDescription}
        />
      </div>

      <div className="payment-screen-layout__input">
        <TextInput
          id="purchase-order-number"
          labelText="Purchase order number (optional)"
          placeholder="Max 255 characters"
          maxLength={255}
          value={purchaseOrderNumber}
          onChange={(event) => onPurchaseOrderNumberChange(event.target.value)}
        />
      </div>

      <div className="payment-screen-layout__section">
        <div className="payment-screen-layout__summary-header">
          Invoice summary
        </div>
        <PricingSummary
          lineItems={lineItems}
          total={total}
          showHeader
          variant="payment"
        />
      </div>
    </div>
  );
};

export default PaymentScreenLayout;
